<script>
import { Doughnut } from "vue-chartjs";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
    extends: Doughnut,
    props: {
        dougnutChartData: {type: Object}
    },
    computed: {
        chartData() {
            return this.dougnutChartData;
        }
    },
    watch: {
        dougnutChartData() {
            this.setDougnut();
        },
        "$i18n.locale"(val){
            this.setDougnut()
        }
    },
    methods:{
        formatter(value, context){
            return value == 0 ? null : context.chart.data.labels[context.dataIndex] + ': \n' +  value;
        },
        align(context){
            return context.dataIndex % 2 ? 'start' : 'end'
        },
        setDougnut(){
            this.addPlugin(ChartDataLabels);

            this.options = {
                plugins: {
                    datalabels: {
                        color: '#1d1d1d',
                        backgroundColor: "#f7f7f7",
                        borderWidth: 1,
                        borderColor: '#f3f3f3',
                        borderRadius: 8,
                        formatter: this.formatter,
                        align: this.align,
                        textAlign: 'center',
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            };

            var itemTypes = this.$i18n.messages[this.$i18n.locale].salon_report.item_types
            var label = this.chartData.label.map(i =>{
                return itemTypes[i]
            })

            this.renderChart(
            {
                labels: label,
                datasets: [
                {
                    backgroundColor: ["#ffb20e", "#107066", "#563d7c", "#ce0262"],
                    data: this.chartData.data,
                },
                ]
            },
            this.options
            );
        }
    },
    mounted() {
        this.setDougnut()
    }
};
</script>